import { render, staticRenderFns } from "./TermConditions.vue?vue&type=template&id=7972bccb&scoped=true"
var script = {}
import style0 from "./TermConditions.vue?vue&type=style&index=0&id=7972bccb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972bccb",
  null
  
)

export default component.exports